<template>
	<v-card outlined elevation="5">
		<v-img
			:src="path"
			class="white--text align-end"
			gradient="to bottom, rgba(0,0,0,.1), rgba(0,56,122,.5)"
			height="200px"
		>
		<div class='text-center'>
		<v-icon large dark>mdi-file</v-icon>

		</div>
			<v-card-title v-text="name" style="word-break: keep-all" />
		</v-img>

		<v-card-actions>
			<v-spacer />

			<v-chip color='primary' label class='mr-2'>{{filetype}}</v-chip>
			<v-chip color='secondary' label>Size: {{Math.round(filesize)}} kB</v-chip>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: 'MediaItem',
	props: {
		path: String,
		name: String,
		text: String,
		filetype: String,
		filesize: Number
	},
}
</script>

<style lang="scss" scoped>
</style>